export default __webpack_public_path__ + "static/media/Content3.8c9b8a18.svg";